import React, { useState, useEffect,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addAdminMenu, resetStatus } from "../../../slice/admin/adminMenuSlice";



export default function Add() {
  const dispatch = useDispatch();
  const buttonRef = useRef(null);

  const { loading, success, error } = useSelector(
    (state) => state.adminMenu
  );

  const [formData, setFormData] = useState({
    title: "",
    path: "",
    icon: "",
    order: 1,
    status: true,
    category: "",
    role: []
  });

useEffect(() => {
  if (success) {
    const toastEl = document.getElementById("successToast");
    if (toastEl) {
      const toast = new window.bootstrap.Toast(toastEl, {
        delay: 2500
      });
      toast.show();
    }

    dispatch(resetStatus());
    setFormData({
      title: "",
      path: "",
      icon: "",
      order: 1,
      status: true,
      category: "",
      role: []
    });
  }
}, [success, dispatch]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRoleChange = (e) => {
    const values = Array.from(e.target.selectedOptions, (o) => o.value);
    setFormData({ ...formData, role: values });
  };

  const handleSubmit = () => {
    dispatch(addAdminMenu(formData));
  };

  return (
    <div className="row">
      <div
  className="toast-container position-fixed top-0 end-0 p-3"
  style={{ zIndex: 1100 }}
>
  <div
    id="successToast"
    className="toast align-items-center text-bg-success border-0"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div className="d-flex">
      <div className="toast-body">
        ✅ Role created successfully
      </div>
      <button
        type="button"
        className="btn-close btn-close-white me-2 m-auto"
        data-bs-dismiss="toast"
      ></button>
    </div>
  </div>
</div>

      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Roles Information</h4>
          </div>

          <div className="card-body">
            <div className="row">

              <div className="col-lg-6 mb-3">
                <label className="form-label">Title</label>
                <input
                  className="form-control"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Path</label>
                <input
                  className="form-control"
                  name="path"
                  value={formData.path}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Icon</label>
                <input
                  className="form-control"
                  name="icon"
                  value={formData.icon}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Category</label>
                <input
                  className="form-control"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Roles</label>
                <select
                  className="form-control"
                  multiple
                  onChange={handleRoleChange}
                >
                  <option value="admin">Admin</option>
                  <option value="manager">Manager</option>
                  <option value="user">User</option>
                </select>
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Status</label>
                <select
                  className="form-control"
                  value={formData.status}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      status: e.target.value === "true"
                    })
                  }
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>

            </div>
          </div>

          <div className="card-footer text-end">
   <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : "Create Role"}
            </button>

          </div>

          {error && <p className="text-danger p-3">{error}</p>}
        </div>
      </div>
    </div>
  );
};

